var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalGroupableChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0753 19.8271H0.539062V0.794922H1.48602V18.8803H21.0753V19.8271Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77344 8.67969H4.01026H5.60844V17.2278H3.77344V8.67969Z",
    fill: "#4F6E90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4766 1.80469H15.7134H17.3116V17.2285H15.4766V1.80469Z",
    fill: "#4F6E90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.58398H9.86182H11.46V17.2281H9.625V7.58398Z",
    fill: "#4F6E90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60938 3.83203H5.84619H7.44438V17.2284H5.60938V3.83203Z",
    fill: "#8DADD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 7.58398H17.5493H19.1475V17.2281H17.3125V7.58398Z",
    fill: "#8DADD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4609 10.2207H11.6978H13.2959V17.2293H11.4609V10.2207Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalGroupableChartIcon);
export default __webpack_public_path__ + "static/media/vertical-groupable-chart-icon.0e055ce579734a1c44c011b6b4ace196.svg";
export { ForwardRef as ReactComponent };